import React from "react";
import { Link, useLocation } from "react-router-dom";
const TestHeader = () => {
  const location = useLocation();

  const isActive = (path:any) => location.pathname === path;
  return (
    <div className="w-full max-w-2xl mx-auto flex flex-row justify-between gap-5 px-10 py-[19px]">
    <Link to="/teststep2"
      className={`text-base font-normal pb-[11px] ${
        isActive('/teststep2') ? 'text-white border-b border-white' : 'text-[#a5a5a5]'
      }`}
    >
      Test
    </Link>
    <Link to="/train"
      className={`text-base font-normal pb-[11px] ${
        isActive('/train') ? 'text-white border-b border-white' : 'text-[#a5a5a5]'
      }`}
    >
      Train
    </Link>
    <Link to="/performance"
      className={`text-base font-normal pb-[11px] 
        ${isActive('/performance') ? 'text-white border-b border-white' : 'text-[#a5a5a5]'
      }`}
    >
      Performance
    </Link>
  </div>
  );
};

export default TestHeader;
